import { render } from "./SapporoCollectionSimpleScreen.vue?vue&type=template&id=1d18ef07&scoped=true&ts=true&lang=pug"
import script from "./SapporoCollectionSimpleScreen.vue?vue&type=script&lang=ts"
export * from "./SapporoCollectionSimpleScreen.vue?vue&type=script&lang=ts"

import "./SapporoCollectionSimpleScreen.vue?vue&type=style&index=0&id=1d18ef07&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d18ef07"]])

export default __exports__